module.exports = __webpack_public_path__ + "img/us.cd4875be.png";